import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssButton, CssInput } from "styles/helpers/layout";

export const StyledEditButton = styled(CssButton)<Props>`
  color: ${(props: Props) => props.theme.palette.secondary.brand};
  :hover {
    color: ${(props: Props) => props.theme.palette.secondary._400 || props.theme.palette.secondary._950}
  }
`;

export const StyledMaxUsageInput = styled(CssInput)`
  border-radius: 4px;
  width: 4.5rem;
  height: 1.5rem;
  padding: 0 0.5rem;
`;

export const StyledNarrowButton = styled(CssButton)`
  height: 1.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  padding: 0 0.75rem;
`;
